import type { RecordingInput } from '@1qa/shared';

/** A pointer moved less than this (emulator pixels) between down and up: a tap, else a swipe. */
export const TAP_SLOP_PX = 30;
/** Held at least this long without moving: a long press. */
export const LONG_PRESS_MS = 600;

/** Where a pointer is on the emulator's screen, in its own pixels, from where it is on the image showing it. */
export function toDevicePixels(clientX: number, clientY: number, rect: { left: number; top: number; width: number; height: number }, natural: { w: number; h: number }) {
  const x = Math.round(((clientX - rect.left) / rect.width) * natural.w);
  const y = Math.round(((clientY - rect.top) / rect.height) * natural.h);
  return { x: Math.min(Math.max(x, 0), natural.w - 1), y: Math.min(Math.max(y, 0), natural.h - 1) };
}

/** A tap, long press or swipe from where the pointer went down and came up, and how long it was down. */
export function gestureOf(down: { x: number; y: number }, up: { x: number; y: number }, ms: number): RecordingInput {
  if (Math.hypot(up.x - down.x, up.y - down.y) < TAP_SLOP_PX) return { kind: 'tap', x: down.x, y: down.y, ...(ms >= LONG_PRESS_MS && { long: true }) };
  return { kind: 'swipe', x0: down.x, y0: down.y, x1: up.x, y1: up.y, ms: Math.min(Math.max(Math.round(ms), 100), 2000) };
}
